import { ICustomerDetails } from "@interface/customerDetails/ICustomerDetails";
import { mapEirSalesCustomerDetails } from "../mappers/mapEirSalesCustomerDetails";
import { fetcher } from "@utils/fetcher";
import { IFetchOptions } from "itsf-ui-common";
import { getCustomerDetailsRoute } from "@api-routes/eirSalesFacade";

export const getCustomerDetails = (options: IFetchOptions = {}) =>
    fetcher<ICustomerDetails>(getCustomerDetailsRoute(), {
        method: "GET",
        mapper: mapEirSalesCustomerDetails,
        ...options,
    });
